var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bloc-header2',{attrs:{"page":"Programme de professionnalisation"}}),_c('div',{staticClass:"containerAffichage"},[_c('bloc-professionnalisation',{attrs:{"sitePro":_vm.sitePro}})],1),_c('bloc-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }